import PropTypes from 'prop-types';

import ExternalSourceShape from './ExternalSourceShape';

export default PropTypes.arrayOf(PropTypes.shape({
  id: PropTypes.string,
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(ExternalSourceShape).isRequired,
}));



// WEBPACK FOOTER //
// ./src/components/ExternalLinksCollection/ExternalLinksShape.js